const localeValues = require("./src/en.json");

module.exports = {
  enUSLocale: {
    locale: "en-US",
    messages: localeValues,
  },
};
